module.exports = new __parcel__URL__("dotNET.cd2a3872.png").toString();